import { useState } from 'react';

const COUNSEL_FIELDS = [
  '아동·청소년 심리상담',
  '학교폭력 피해 상담',
  '부모·가족 상담',
  '정신건강 심리상담',
  '진로·학업 상담',
  '기타',
];

export default function Booking() {
  const [submitted, setSubmitted] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const content = (form.elements.namedItem('content') as HTMLTextAreaElement).value;
    if (content.length > 500) return;

    const data = new URLSearchParams();
    Array.from(new FormData(form)).forEach(([key, value]) => {
      data.append(key, value as string);
    });

    await fetch('https://readdy.ai/api/form/d6n2qriqoe30lj0v8hj0', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: data.toString(),
    });

    setSubmitted(true);
  };

  return (
    <section id="booking" className="py-20 bg-[#7A8A72]">
      <div className="max-w-4xl mx-auto px-6">
        <div className="bg-[#6B7A63] rounded-[36px] px-14 py-16 text-center">
          <div className="flex justify-center mb-5">
            <i className="ri-chat-quote-line text-4xl text-white/80"></i>
          </div>

          <h2 className="text-[22px] font-bold text-white leading-relaxed mb-6">
            혼자 나누기 어려운 마음이 있다면<br />
            잠시 멈춰 서서 이야기를 나누세요.<br />
            당신의 이야기는 충분히 소중합니다.
          </h2>

          <p className="text-[14px] text-white/90 leading-relaxed mb-8">
            우리는 당신이 더 편안한 마음으로<br />
            삶을 살아갈 수 있도록 함께하겠습니다.
          </p>

          {submitted ? (
            <div className="bg-white/20 rounded-2xl px-8 py-10 text-white">
              <div className="w-14 h-14 flex items-center justify-center mx-auto mb-3">
                <i className="ri-checkbox-circle-line text-4xl text-white"></i>
              </div>
              <p className="text-[18px] font-bold mb-2">신청이 완료되었습니다!</p>
              <p className="text-white/80 text-[13px] mb-6">빠른 시일 내에 연락드리겠습니다.</p>

              <div className="bg-white/15 rounded-xl px-6 py-5 text-left space-y-3">
                <p className="text-[13px] font-semibold text-white text-center mb-3">📩 예약 확인 안내</p>
                <div className="flex items-start gap-3">
                  <div className="w-7 h-7 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-kakao-talk-fill text-xl text-yellow-300"></i>
                  </div>
                  <div>
                    <p className="text-[12px] font-semibold text-white/90 mb-0.5">카카오톡 채널</p>
                    <p className="text-[12px] text-white/75 leading-relaxed">
                      카카오톡에서 <strong className="text-white">'닥터리즈심리상담센터'</strong>를 검색하시면<br />
                      채널을 통해 예약 확인 및 상담 문의가 가능합니다.
                    </p>
                  </div>
                </div>
                <div className="border-t border-white/20 pt-3 flex items-start gap-3">
                  <div className="w-7 h-7 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-message-2-line text-xl text-white/80"></i>
                  </div>
                  <div>
                    <p className="text-[12px] font-semibold text-white/90 mb-0.5">문자 안내</p>
                    <p className="text-[12px] text-white/75 leading-relaxed">
                      신청하신 연락처로 예약 확인 문자가 발송됩니다.<br />
                      문의사항은 <strong className="text-white">010-4827-0275</strong>로 문자 주세요.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <form
              data-readdy-form
              id="counsel-apply-form"
              onSubmit={handleSubmit}
              className="bg-white/10 rounded-2xl px-8 py-8 text-left space-y-4"
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-white/80 text-[12px] mb-1.5 font-medium">이름 <span className="text-white/60">*</span></label>
                  <input
                    type="text"
                    name="name"
                    required
                    placeholder="이름을 입력해주세요"
                    className="w-full px-3 py-2.5 rounded-xl bg-white/20 text-white placeholder-white/50 text-[13px] focus:outline-none focus:ring-2 focus:ring-white/40"
                  />
                </div>
                <div>
                  <label className="block text-white/80 text-[12px] mb-1.5 font-medium">연락처 <span className="text-white/60">*</span></label>
                  <input
                    type="tel"
                    name="phone"
                    required
                    placeholder="010-0000-0000"
                    className="w-full px-3 py-2.5 rounded-xl bg-white/20 text-white placeholder-white/50 text-[13px] focus:outline-none focus:ring-2 focus:ring-white/40"
                  />
                </div>
              </div>

              <div>
                <label className="block text-white/80 text-[12px] mb-1.5 font-medium">상담 희망 분야 <span className="text-white/60">*</span></label>
                <select
                  name="field"
                  required
                  className="w-full px-3 py-2.5 rounded-xl bg-white/20 text-white text-[13px] focus:outline-none focus:ring-2 focus:ring-white/40 cursor-pointer"
                >
                  <option value="" disabled selected className="text-gray-700">분야를 선택해주세요</option>
                  {COUNSEL_FIELDS.map((f) => (
                    <option key={f} value={f} className="text-gray-800">{f}</option>
                  ))}
                </select>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-white/80 text-[12px] mb-1.5 font-medium">
                    희망 상담 날짜 <span className="text-white/60">*</span>
                  </label>
                  <input
                    type="date"
                    name="preferred_date"
                    required
                    min={new Date().toISOString().split('T')[0]}
                    className="w-full px-3 py-2.5 rounded-xl bg-white/20 text-white text-[13px] focus:outline-none focus:ring-2 focus:ring-white/40 cursor-pointer [color-scheme:dark]"
                  />
                </div>
                <div>
                  <label className="block text-white/80 text-[12px] mb-1.5 font-medium">
                    희망 상담 시간 <span className="text-white/60">*</span>
                  </label>
                  <select
                    name="preferred_time"
                    required
                    className="w-full px-3 py-2.5 rounded-xl bg-white/20 text-white text-[13px] focus:outline-none focus:ring-2 focus:ring-white/40 cursor-pointer"
                  >
                    <option value="" disabled selected className="text-gray-700">시간을 선택해주세요</option>
                    <option value="10:00" className="text-gray-800">오전 10:00</option>
                    <option value="11:00" className="text-gray-800">오전 11:00</option>
                    <option value="12:00" className="text-gray-800">오후 12:00</option>
                    <option value="13:00" className="text-gray-800">오후 1:00</option>
                    <option value="14:00" className="text-gray-800">오후 2:00</option>
                    <option value="15:00" className="text-gray-800">오후 3:00</option>
                    <option value="16:00" className="text-gray-800">오후 4:00</option>
                    <option value="17:00" className="text-gray-800">오후 5:00</option>
                    <option value="18:00" className="text-gray-800">오후 6:00</option>
                    <option value="19:00" className="text-gray-800">오후 7:00</option>
                    <option value="20:00" className="text-gray-800">오후 8:00</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-white/80 text-[12px] mb-1.5 font-medium">
                  간단한 상담 내용
                  <span className="ml-2 text-white/50 font-normal">({charCount}/500자)</span>
                </label>
                <textarea
                  name="content"
                  rows={4}
                  maxLength={500}
                  placeholder="상담받고 싶은 내용을 간단히 적어주세요. (선택)"
                  onChange={(e) => setCharCount(e.target.value.length)}
                  className="w-full px-3 py-2.5 rounded-xl bg-white/20 text-white placeholder-white/50 text-[13px] focus:outline-none focus:ring-2 focus:ring-white/40 resize-none"
                />
                {charCount > 500 && (
                  <p className="text-red-300 text-[11px] mt-1">500자를 초과할 수 없습니다.</p>
                )}
              </div>

              <div className="pt-1 text-center">
                <button
                  type="submit"
                  className="px-12 py-3 bg-white text-[#7A8A72] text-[14px] font-bold rounded-full hover:bg-[#FAF8F5] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  상담 신청하기
                </button>
              </div>
            </form>
          )}

          <div className="mt-12 pt-10 border-t border-white/20">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-white">
              <div>
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-phone-line text-2xl"></i>
                </div>
                <p className="text-[13px] text-white/70 mb-1">전화 상담</p>
                <p className="text-[15px] font-semibold">010-4827-0275</p>
              </div>
              <div>
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-time-line text-2xl"></i>
                </div>
                <p className="text-[13px] text-white/70 mb-1">운영 시간</p>
                <p className="text-[15px] font-semibold">평일 10:00 - 20:00</p>
                <p className="text-[13px] text-white/80 mt-1">토요일 10:00 - 15:00</p>
                <p className="text-[11px] text-white/60 mt-0.5">(사전예약 후 20:00까지 가능)</p>
              </div>
              <div>
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                  <i className="ri-mail-line text-2xl"></i>
                </div>
                <p className="text-[13px] text-white/70 mb-1">이메일</p>
                <p className="text-[15px] font-semibold">eunmilee724@daum.net</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
